// TODO(types): switch to OpenAPI-generated types once the consumer quote DTOs land in codegen.
// These mirror Belong.Models.Consumer/Maintenance/MaintenanceQuoteConsumerModel.cs

type MaintenanceQuoteType = 'SecondOpinion' | 'FollowUpWork';

type MaintenanceQuoteStatus =
  | 'Draft'
  | 'Published'
  | 'Approved'
  | 'NotSelected'
  | 'Rejected';

type MaintenanceQuoteParty = 'Homeowner' | 'Resident' | 'Belong';

export type MaintenanceQuoteConsentStatus =
  | 'Required'
  | 'NotRequired'
  | 'Approved'
  | 'Rejected';

export type MaintenanceQuoteRejectionReason =
  | 'TooExpensive'
  | 'WantSecondOpinionFromAnotherPro'
  | 'Other';

export type MaintenanceQuoteCostItemType =
  | 'Labor'
  | 'Parts'
  | 'Other'
  | 'VendorFee'
  | 'Procurement'
  | 'Dispatch'
  | 'WasteDisposal'
  | 'ProjectCoordination'
  | 'BelongMargin'
  | 'Discount';

export interface MaintenanceQuoteCostItemConsumerModel {
  uniqueId: string;
  type: MaintenanceQuoteCostItemType;
  description: string | null;
  quantity: number;
  unitRate: number;
  cost: number;
}

interface MaintenanceQuoteProConsumerModel {
  id: number;
  name: string;
  profileImageUrl?: string | null;
  userId?: string | null;
}

interface MaintenanceQuotePartyConsentModel {
  party: MaintenanceQuoteParty;
  consentStatus: MaintenanceQuoteConsentStatus;
  percentage: number;
}

interface MaintenanceQuoteApprovalConsumerModel {
  party: MaintenanceQuoteParty;
  percentage: number;
  consentStatus: MaintenanceQuoteConsentStatus;
  consentOn: string | null;
  notes: string | null;
  rejectionReason: MaintenanceQuoteRejectionReason | null;
  estimatedAmount: number;
}

type QuoteTypeOfWork =
  | 'ShortTermRepair'
  | 'LongTermRepair'
  | 'Replacement'
  | 'LowEndReplacement'
  | 'HighEndReplacement';

export const QuoteTypeOfWorkLabels: Record<QuoteTypeOfWork, string> = {
  ShortTermRepair: 'Short-Term Repair',
  LongTermRepair: 'Long-Term Repair',
  Replacement: 'Equivalent Replace',
  LowEndReplacement: 'Low-End Replace',
  HighEndReplacement: 'High-End Replace',
};

export interface MaintenanceQuoteConsumerModel {
  typeOfWork?: QuoteTypeOfWork;
  uniqueId: string;
  parentQuoteUniqueId?: string | null;
  quoteType: MaintenanceQuoteType | null;
  status: MaintenanceQuoteStatus;
  title: string;
  scopeOfWork: string;
  findings: string;
  totalAmount: number;
  isBlindQuote: boolean;
  isRecommended: boolean;
  createdOn: string;
  assignedPro: MaintenanceQuoteProConsumerModel | null;
  costItems: MaintenanceQuoteCostItemConsumerModel[];
  approvals: MaintenanceQuotePartyConsentModel[];
  myApproval: MaintenanceQuoteApprovalConsumerModel | null;
  myEstimatedAmount: number | null;
}
